import styled from 'styled-components';

export const FormContainer = styled.div`
  padding: 10px 24px;
`;

export const Form = styled.form`
  padding-bottom: 20px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  align-items: center;
  width: 100%;
  margin-top: 15px;
`;
